<template>
  <div class="pc_consulting">
    <div class="parse">
      <!-- <h2>询盘</h2> -->
      <ul v-if="inbox.length" class="consu_list" >
        <li class="consu_item" v-for="(item,i) in inbox" :key="'inbox'+i" @click="open(item)">
          <div class="accordingState">
            <img v-if="item.status*1==1?false:true" :src="hrefurl+'/public/icon/unread.png'" alt=""/><!--未读-->
            <img v-else :src="hrefurl+'/public/icon/read.png'" alt=""/><!--已读-->
          </div>
          <div class="consu_item_zuo">
            <!-- <el-badge value="new" class="item" :hidden="item.status*1==1?true:false"> -->
              <div class="consu_item_left">
                <img :src="item.img" alt="" />
              </div>
              <div class="consu_item_right">
                <p class="consu_name">
                  {{item.name?item.name:item.nickname}}
                  <span>{{item.ctime}}</span>
                  </p>
                <p class="consu_content">
                  {{item.content}}
                </p>
              </div>
              <span class="consu_time"></span>
            <!-- </el-badge> -->
          </div>
          <div class="consu_item_you">
            <img :src="item.img_url" alt=""/>
          </div>
        </li>
      </ul>
      <div class="null" v-else>
        <div>
          <img :src="hrefurl+'/public/icon/without.png'" alt=""/>
        </div>
         No data is available!
      </div>

    </div>
    <el-dialog
      v-if="detailObj.pro_info"
      modal-append-to-body="false"
      :title="detailObj.corp_info.corpname_cn"
      :visible.sync="centerDialogVisible"
      :before-close="befColse"
      width="660px"
      class="tanchuang"
      center>
      <div class="dialogue">
        <div class="liebiao">
          <ul class="messagelist" ref="box">
            <li  v-for="(item,i) in detailObj.list" :key="'msg'+i">
              <div v-if="item.sendid*1!==user.id*1" class="messageitem">
                <div class="msgImg">
                  <img :src="item.send_img" alt=""/>
                </div>
                <div class="msgcontent">
                  <p class="consu_name1">
                    {{item.send_name?item.send_name:item.send_nickname}}
                    <span>{{item.ctime}}</span>
                  </p>
                  <p class="usercontent">
                    {{item.content}}
                  </p>
                </div>
                <div v-if="item.sendid==user.id" class="btndel" style="display:none">
                  <el-button type="danger" @click="eachDel(item.id)" plain>Recall</el-button>
                </div>
              </div>
              <div v-else class="messageitem1">
                <div class="msgcontent1">
                  <p class="consu_name2">
                    {{item.send_name?item.send_name:item.send_nickname}}
                    <span>{{item.ctime}}</span>
                  </p>
                  <p class="usercontent1">
                    {{item.content}}
                  </p>
                </div>
                <div class="msgImg">
                  <img :src="item.send_img" alt=""/>
                </div>
                <div v-if="item.sendid==user.id" class="btndel" style="display:none">
                  <el-button type="danger" @click="eachDel(item.id)" plain>Recall</el-button>
                </div>
              </div>
              
            </li>
          </ul>
          <div class="inputsend">
            <el-input
              type="textarea"
              placeholder="Input Message"
              v-model="textarea"
              maxlength="200"
              show-word-limit
            >
            </el-input>
            <el-button type="primary" @click="msgSend">Send</el-button>
          </div>
        </div>
        <div class="introduce">
          <div class="corplogo">
            <img :src="detailObj.corp_info.corplogo_cn" alt=""/>
          </div>
          <p class="introduceP">Welcome！We will be glad to be at your service</p>
          <div class="pro_info">
            <img :src="detailObj.pro_info.img_url" alt=""/>
          </div>
          <h3>{{detailObj.pro_info.proname_en}}</h3>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { reqMynote, reqMynoteOne, reqMynoteAdd, reqNoteDel, } from '../../../../api'
export default {
  data(){
    return{
      inbox:[],
      detailObj:{},
      textarea:"",
      centerDialogVisible:true,
      item:{},
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(){
      const response = await reqMynote()
      if (response.code==2) {
        // this.inbox=response.inbox
       this.inbox = this.screening(response.inbox)
      }
    },
    async open(item){//详情
      this.item = item
      const response = await reqMynoteOne(item.sendid,item.putid,item.pid)
      if (response.code==3) {//数据正常
        this.detailObj = {
          corp_info:response.corp_info,
          pro_info:response.pro_info,
          list:response.reslist.reverse(),
        }
        this.centerDialogVisible=true
        setTimeout(()=>{
          this.$refs.box.scrollTop = this.$refs.box.scrollHeight
        })
      }else if(response.code==2){
        if (this.centerDialogVisible) {//判断是否是在详情页面
          this.centerDialogVisible=false
          this.init()
        }
      }
    },
    async msgSend(){//发送
     let putid = this.user.id==this.detailObj.list[0].putid?this.detailObj.list[0].sendid:this.detailObj.list[0].putid
      const response = await reqMynoteAdd(putid,this.detailObj.list[0].pid,this.textarea)
      if (response.code==3) {
        this.textarea=''
        this.open(this.item)
      }else if (response.code==2) {
        console.log(response.msg);
      }else if (response.code==1) {
        console.log(response.msg);
      }else if (response.code==0) {
        console.log(response.msg);
      }
    },
    screening(arr){
      for(var i=0; i<arr.length; i++){//数组去重
        for(var j=i+1; j<arr.length; j++){
          if(arr[i].id*1==arr[j].id*1){
            arr.splice(j,1);
            j--;
          }
        }
        }
      return arr;
    },
    async eachDel(id){//留言删除
      const response = await reqNoteDel(id)
      if (response.code*1==3) {
        this.success(this,'Delete Successfully!')
        this.open(this.item)
      }else{
        this.err(this,'Timeout, please try...')
      }
    },
    befColse(){
      this.centerDialogVisible=false
      this.init()
    }
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
  watch: {

  }
}
</script>

<style scoped>
  .pc_consulting{
    width: 100%;
  }
  .parse{
    width: 100%;
    background-color: white;
    border-radius: 4px;
    margin: auto;
    position: relative;
  }
  .pc_consulting h2{
    width: 100%;
    line-height: 56px;
    text-align: center;
    background-color: rgb(209, 208, 219);
    font-weight: 600;
    position: absolute;
    left: 0;
    top: 0;
  }
  .consu_list{
    background-color: white;
    padding: 0px 0 10px;
  }

  .consu_item{
    position: relative;
    padding: 12px 6px;
    display: flex;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    height: 130px;
  }
  .consu_item:hover{
    background-color: #e6e6e6;
  }
  .accordingState{
    width: 40px;
    padding: 0 10px;
  }
  .accordingState img{
    width: 100%;
  }
  .consu_item_zuo{
    width: 50%;
    padding: 24px 0;
    display: flex;
  }
  /* .consu_item_zuo>>>.el-badge{
    display: flex;
  } */
  .consu_item_zuo>>>.el-badge__content{
    border: none;
    height: 14px;
    padding: 0 2px;
    line-height: 12px;
    top: 0;
    left: 0;
    width:34px;
  }
  .consu_item_left{
    width: 46px;
    height: 46px;
    min-width: 46px;
    background-color: royalblue;
    border-radius: 6px;
  }
  .consu_item_right{
    margin-left: 6px;
    
  }
  .consu_name{
    font-size: 14px;
    margin-bottom: 6px;
    text-align: left;
  }
  .consu_name>span{
    font-size: 12px;
    color: #666666;
  }
  .consu_content{
    font-size: 12px;
    color: #636363;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .consu_time{
    position: absolute;
    right: 6px;
    top: 40%;
  }
  .consu_button{
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 34px;
  }
  .consu_button>>>.el-button{
    padding: 0 7px;
    width: 34px;
    height: 100%;
    white-space: pre-wrap;
    text-align: center;
    writing-mode:lr-tb;
  }
  .consu_item_you{
    width: 50%;
    text-align: center;
  }
  .consu_item_you >img{
    background-color: white;
    height: 100%;
    width: 200px;
    border: 1px solid #aaa;
    border-radius: 6px;
  }
  .null{
    padding-bottom: 200px;
    text-align: center;
  }
  .null>div{
    
    width: 200px;
    margin: 20px auto;
  }


  /* 弹窗头部 satrt */
  .tanchuang >>>.el-dialog__header{
    background: #008baf;
  }
  .tanchuang >>>.el-dialog__title{
    color: white;
  }
  .tanchuang>>>.el-icon-close:before{
    color: white;
  }
  /* 弹窗头部 end */

  /* 左侧列表  start*/

  .consu_header{
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding: 0 10px;
    text-align: center;
  }
  .consu_header>span:first-child{
    float: left;
  }
  .consu_header>span:last-child{
    margin-left: -20px;
  }
  /* 左侧列表 start */
  .pc_consulting >>>.el-dialog__wrapper .el-dialog__body{
    padding: 0;
  }


  .liebiao{
    width: 440px;
    display: inline-block;
    border-right: 1px solid #aaa;
  }
  .messagelist{
    height: 400px;
    overflow: auto;
    vertical-align: bottom;
    background-color: #f5f5f5;
    letter-spacing: 0;
  }
  .messageitem{
    display: flex;
    padding: 10px;
  }
  .messageitem1{
    display: flex;
    padding: 10px;
    justify-content: flex-end;
  }
  .msgImg{
    width: 48px;
    height: 48px;
    border-radius: 4px;
    overflow: hidden;
  }
  .msgcontent{
    /* margin-left: 10px; */
    padding: 0 6px 6px 6px;
    max-width: calc(100% - 100px);
  }
  .msgcontent1{
    /* margin-left: 10px; */
    padding: 0 6px 6px 6px;
    width: auto;
    max-width: calc(100% - 100px);
  }
  .consu_name{
    color: #008baf;
  }
  .consu_name1{
    /* display: none; */
    color: #008baf;
    font-size: 12px;
    margin-bottom: 2px;
  }
  .consu_name2{
    /* display: none; */
    color: #008baf;
    font-size: 12px;
    margin-bottom: 2px;
    text-align: end;
    padding-right: 4px;
  }
  .usercontent{
    box-sizing: border-box;
    font-size: 14px;
    color: #333;
    background-color: white;
    text-align: left;
    padding: 3px 6px;
    border-radius: 6px;
  }
  .usercontent1{
    box-sizing: border-box;
    font-size: 14px;
    color: white;
    background-color: #008baf;
    text-align: left;
    padding: 3px 6px;
    border-radius: 6px;
  }
  /* 输入框 start */
  .inputsend{
    padding: 20px 10px;
    background-color: #e6e6e6;
    width: 100%;
    
  }
  .inputsend::after{
    display: block;
    content: "";
    clear: both;
  }
  .inputsend>>>.el-textarea__inner{
    height: 140px;
  }
  
   .el-button--primary{
     float: right;
     margin: 6px 6px 0 0;
   }
   .el-button--primary:hover{
     background-color: #f08300;
     border-color: #f08300;
   }
  /* 输入框 end */

  

  /* 左侧列表 end */

  /* 介绍 start */
  .introduce{
    width: 200px;
    display: inline-block;
    height: 400px;
    padding-top: 6%;
    vertical-align: top;
  }
  .corplogo{
    width: 64px;
    height: 64px;
    margin: auto;
  }
  .introduceP{
    font-size: 14px;
    text-indent: 2em;
    padding: 20px 10px;
  }
  
  .pro_info{
    width: 90%;
    padding: 10%;
    border: 1px solid #dcdddd;
    margin: auto;
  }
  .introduce h3{
    font-size: 14px;
    color: #008baf;
    text-align: center;
    width: 100%;
    padding: 20px 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  /* 介绍 end*/
  
</style>